export default "__VITE_ASSET__B1_t_Oj1__"